import { atom } from "jotai";

export const selectedTabAtom = atom<string>('price');
export const selectedPriceAtom = atom<number | null>(null);
export const selectedCategoryAtom = atom<string | null>(null);
export const selectedAwardAtom = atom<string | null>(null);
export const viewTypeAtom = atom<'list' | 'map'>('list');
